import { createContext } from 'react';

export const CartContext = createContext({
  productsNumber: 0,
  load: async (userId: string, token: string) => {},
});
